export default __webpack_public_path__ + "static/media/IMS2.98e79fe7.jpg";